export const OPEN_CHAT = "OPEN_CHAT";
export const CLOSE_CHAT = "CLOSE_CHAT";
export const CHANGE_SELECTED_INFLUENCER = "CHANGE_SELECTED_INFLUENCER";